<template>
  <div class="container h-max is-vertical-center has-text-centered">
    <div v-show="step === -1" class="is-uppercase is-fullwidth">
      <div class="fixed-tl is-fullwidth">
        <img v-if="$store.getters.isMH" src="@/../static/muscle_heroes_logo.svg" class="is-inline-block is-xlarge icon" />
        <img v-else src="@/../static/keepyou.fit.svg" class="is-inline-block is-xlarge icon" />
      </div> 
      <div class="m-t-xl">
        <p class="is-size-2" style="line-height: 1;">{{ $t('Create your') }}<br>{{ $t('new account') }}</p>
      </div>
      <div class="m-t-md m-b-lg">
        <button class="p-l-xxl p-r-xxl has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded" @click="onStart">{{ 'Start' | translate }}</button>
      </div>
      <div class="fixed-bl is-fullwidth">
        <Footer/>
      </div>
    </div>
    <div v-show="step >= 0" class="fixed-tl m-t-md is-fullwidth is-size-4 has-text-primary">{{ 'Your Profile' | translate }}</div>
    <div @click="back" v-show="step >= 1" class="fixed-tl m-t-md m-l-sm">
      <img src="@/../static/svg/arrow-left.svg" class="is-medium icon" style="opacity:0.5;">
    </div>
    <div @click="showMenu" v-show="step >= 0" class="fixed-tr m-t-md m-r-sm">
      <img src="@/../static/svg/menu.svg" class="is-medium icon" style="opacity:0.5;">
    </div>
    <div v-show="step === 0" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-3">{{ 'My name is' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p><input class="input is-size-5 profile-input" v-model="profile.surname" type="text" :placeholder="$t('Surname').toUpperCase()"></p>
        <p><input class="input is-size-5 profile-input" v-model="profile.lastname" type="text" :placeholder="$t('Lastname').toUpperCase()"></p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <a :class="'link is-size-5 ' + (hasName ? colorActive : colorInactive)" @click="commitProfile">{{ 'Continue' | translate }}</a>
        <Footer/>
      </div>
    </div>
    <div v-show="step === 1" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-3">{{ 'I\'m a' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p><button :class="'button is-size-5 is-rounded is-fullwidth profile-input ' + (profile.sex == 'Woman' ? 'has-background-primary has-text-white' : '')" @click="selectOne('sex', 'Woman')">{{ 'Woman' | translate }}</button></p>
        <p><button :class="'button is-size-5 is-rounded is-fullwidth profile-input ' + (profile.sex == 'Man' ? 'has-background-primary has-text-white' : '')" @click="selectOne('sex', 'Man')">{{ 'Man' | translate }}</button></p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <Footer/>
      </div>
    </div>
    <div v-show="step === 2" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-3">{{ 'My age' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p><input class="slider is-fullwidth profile-input is-medium is-circle" step="1" min="10" max="100" value="25" type="range" v-model="profile.age"></p>
        <hr class="has-background-grey-light">
        <p class="has-text-right">{{ profile.age || 25 }} {{ 'years old' | translate }}</p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <a :class="'link is-size-5 ' + (isAbove0('age') ? colorActive : colorInactive)" @click="selectOne('age', parseInt(profile.age))">{{ 'Continue' | translate }}</a>
        <Footer/>
      </div>
    </div>
    <div v-show="step === 3" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-3">{{ 'My height' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p><input class="input profile-input"  type="number" v-model="profile.height"> cm</p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <a :class="'link is-size-5 ' + (isAbove0('height') ? colorActive : colorInactive)" @click="selectOne('height', parseInt(profile.height))">{{ 'Continue' | translate }}</a>
        <Footer/>
      </div>
    </div>
    <div v-show="step === 4" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-3">{{ 'My weight' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p><input class="input profile-input"  type="number" v-model="profile.weight"> kg</p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <a :class="'link is-size-5 ' + (isAbove0('weight') ? colorActive : colorInactive)" @click="selectOne('weight', parseInt(profile.weight))">{{ 'Continue' | translate }}</a>
        <Footer/>
      </div>
    </div>
    <div v-show="step === 5" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-3">{{ 'My body' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <div class="profile-box-group">
            <button :class="'profile-box-1 is-size-4 ' + (profile.body == 'Skinny' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('body', 'Skinny')">{{ 'BRSkinny' | translate }}</button>
            <button :class="'profile-box-2 is-size-4 ' + (profile.body == 'Average' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('body', 'Average')">{{ 'BRAverage' | translate }}</button>
        </div>
        <div class="profile-box-group">
            <button :class="'profile-box-1 is-size-4 ' + (profile.body == 'Corpulent' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('body', 'Corpulent')">{{ 'BRCorpulent' | translate }}</button>
            <button :class="'profile-box-2 is-size-4 ' + (profile.body == 'Muscular' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('body', 'Muscular')">{{ 'BRMuscular' | translate }}</button>
        </div>
      </div>
      <div class="fixed-bl is-fullwidth">
        <Footer/>
      </div>
    </div>
    <div v-show="step === 6" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-3">{{ 'My goal' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <div class="profile-box-group">
          <button :class="'profile-box-1 is-size-4 ' + (profile.goal == 'Health' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('goal', 'Health')">{{ 'BRHealth' | translate }}</button>
          <button :class="'profile-box-2 is-size-4 ' + (profile.goal == 'Endurance' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('goal', 'Endurance')">{{ 'BREndurance' | translate }}</button>
        </div>
        <div class="profile-box-group">
          <button :class="'profile-box-1 is-size-4 ' + (profile.goal == 'Appearance' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('goal', 'Appearance')">{{ 'BRAppearance' | translate }}</button>
          <button :class="'profile-box-2 is-size-4 ' + (profile.goal == 'Strength' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('goal', 'Strength')">{{ 'BRStrength' | translate }}</button>
        </div>
      </div>
      <div class="fixed-bl is-fullwidth">
        <Footer/>
      </div>
    </div>
    <ProfileMenu ref="menu" :show="show" v-on:go="go" />
  </div>
</template>

<script>
import axios from 'axios'
import Footer from '@/components/Footer'
import ProfileMenu from '@/components/ProfileMenu'


export default {
  name: 'CreateProfile',
  data () {
    return {
      start: false,
      colorActive: this.$store.getters.isMH ? 'has-text-grey-darker' : 'has-text-white',
      colorInactive: this.$store.getters.isMH ? 'has-text-grey-light' : 'has-text-grey-light',
      profile: {
        surname: null,
        lastname: null,
        sex: null,
        age: null,
        height: null,
        weight: null,
        body: null,
        goal: null
      },
      step: -1,
      show: false
    }
  },
  computed: {
    hasName() {
      return typeof this.profile.surname === 'string' && typeof this.profile.lastname === 'string' && this.profile.surname.length > 0 && this.profile.lastname.length > 0
    }
  },
  methods: {
    showMenu () {
      this.$refs.menu.showMe()
    },
    onStart() {
      this.step = 0
    },
    back() {
      this.step--
    },
    go(n) {
      this.step = n
    },
    selectOne(key, val) {
      this.profile[key] = val
      this.commitProfile()
    },
    commitProfile() {
      this.$store.dispatch('updateProfile', this.profile)
      this.step++
      if (this.step > 6) {
        this.$router.push({ name: 'Home' })
      }
    },
    isAbove0(key) {
      return parseInt(this.profile[key]) > 0
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'LP' })
      }
    } 
  },
  components: {
    Footer,
    ProfileMenu
  }
}
</script>

<style>
    .profile-input {
      text-align: center;
      margin-bottom: 0.4em;
    }
    .profile-box-group {
      position: relative;
      width: 14rem;
      height: 7rem;
      margin: auto;
    }
    .profile-box-1, .profile-box-2 {
      width: 6rem;
      height: 6rem;
      margin: 0.5rem;
      padding: 0.5rem;
      align-items: center;
      border-radius: 1rem;
      text-align: center;
      display: grid;
      justify-content: center;
      position: absolute;
    }
    .profile-box-1 {
      left: 0;
      top: 0;
    }
    .profile-box-2 {
      left: 7rem;
      top: 0;
    }
    input[type="range"].slider.is-medium:not([orient="vertical"])::-webkit-slider-runnable-track,
    input[type="range"].slider.is-medium:not([orient="vertical"])::-moz-range-track,
    input[type="range"].slider.is-medium:not([orient="vertical"])::-ms-track
    {
        height: 0.2rem !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/CreateProfile.vue